/**
 * kb-base-select.tsx — Chọn KHO tri thức (dùng ở mọi nơi tạo kiến thức: thêm hỏi đáp, tải tài liệu, sửa câu trả lời →
 * lưu thành hỏi đáp, câu hỏi chưa trả lời được, "Cho AI dùng"…).
 * `autoLabel` có giá trị → thêm lựa chọn "tự chọn" (máy chủ chọn kho đầu tiên của nhân viên AI / "Kho mặc định").
 */
import { useTranslation } from 'react-i18next'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useKnowledgeBases } from '@/hooks/use-knowledge-bases'
import { cn } from '@/lib/utils'

const AUTO = '__auto__'

export function KnowledgeBaseSelect({ value, onChange, autoLabel, className, disabled, ariaLabel }: {
  value: string
  onChange: (id: string) => void
  /** Nhãn lựa chọn "để hệ thống chọn kho" (giá trị ''). Bỏ trống = bắt buộc chọn kho. */
  autoLabel?: string
  className?: string
  disabled?: boolean
  ariaLabel?: string
}) {
  const { t } = useTranslation('aiKnow')
  const { data: bases } = useKnowledgeBases()
  const list = bases ?? []
  return (
    <Select
      value={value || (autoLabel ? AUTO : '')}
      onValueChange={(v) => onChange(v === AUTO ? '' : v)}
      disabled={disabled}
    >
      <SelectTrigger className={cn('h-9', className)} aria-label={ariaLabel ?? t('baseSelect.ariaLabel')}>
        <SelectValue placeholder={list.length ? t('baseSelect.placeholder') : t('baseSelect.noBases')} />
      </SelectTrigger>
      <SelectContent>
        {autoLabel && <SelectItem value={AUTO}>{autoLabel}</SelectItem>}
        {list.map((b) => <SelectItem key={b.id} value={b.id}>📚 {b.name}</SelectItem>)}
      </SelectContent>
    </Select>
  )
}
